import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';
import { AthleteRetrieve } from 'types';

interface IAthleteStatusBadgeProps extends BadgeProps {
  status: AthleteRetrieve['athleteStatus'];
}

const statusColorMap: { [key: string]: string } = {
  Prospect: 'gray',
  Visitor: 'yellow',
  Trial: 'blue',
  'Non-Paying Member': 'orange',
  Member: 'green',
  Alumni: 'red',
};

const AthleteStatusBadge = ({ status, ...props }: IAthleteStatusBadgeProps): JSX.Element | null => {
  if (status === null) return null;
  return (
    <Badge color={statusColorMap[status]} {...props}>
      {status}
    </Badge>
  );
};

export default AthleteStatusBadge;
